import { Fragment } from "react/jsx-runtime";
import {
  MiModalConfirm,
  MiWorkOrderCard,
  MiWorkOrderCardProps,
} from "@miplatform/components";
import { ATTEMPT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { useBoolean } from "@miplatform/hooks";
import {
  mdiAccountCancel,
  mdiFormatListBulleted,
  mdiHandBackRightOutline,
} from "@mdi/js";
import { useTheme } from "@mui/material";
import { useCalendarContext } from "../../../providers/CalendarProvider/CalendarProvider";
import { HoldAttemptFormData } from "../NhcCalendar.types";
import { WorkOrderHoldModal } from "../WorkOrderHoldModal/WorkOrderHoldModal";

export const NHCWorkOrderCard = (props: MiWorkOrderCardProps) => {
  const theme = useTheme();
  const { attempt } = props;
  const [isHoldModalOpen, handleHoldModalOpen, handleHoldModalClose] =
    useBoolean();
  const [
    isUnassignModalOpen,
    handleUnassignModalOpen,
    handleUnassignModalClose,
  ] = useBoolean();
  const {
    isCalendarLoading,
    calendarSet,
    setSelectedAttempt,
    holdWorkOrder,
    unscheduleAttempt,
    refreshData,
  } = useCalendarContext();
  const isHoldHidden =
    attempt.attemptStatus === ATTEMPT_STATUSES.HOLD ||
    attempt.attemptStatus === ATTEMPT_STATUSES.CANCELLED ||
    attempt.attemptStatus === ATTEMPT_STATUSES.CLOSED;
  const isUnassignHidden =
    !attempt.assignedUserId ||
    attempt.attemptStatus === ATTEMPT_STATUSES.CANCELLED ||
    attempt.attemptStatus === ATTEMPT_STATUSES.CLOSED;

  const menuItems = [
    {
      label: "Hold",
      icon: mdiHandBackRightOutline,
      color: theme.palette.purple.dark,
      action: handleHoldModalOpen,
      hide: isHoldHidden,
    },
    {
      label: "Unassign",
      icon: mdiAccountCancel,
      color: theme.palette.red.main,
      action: handleUnassignModalOpen,
      hide: isUnassignHidden,
    },
    {
      label: "Details",
      icon: mdiFormatListBulleted,
      color: theme.palette.grey.darkerAccent as string,
      action: () => setSelectedAttempt(attempt),
    },
  ];

  const submitHold = async (data: HoldAttemptFormData) => {
    const response = await holdWorkOrder(data);

    if (response.status === HTTP_STATUSES.OK) {
      handleHoldModalClose();
      refreshData();
    }
  };

  return (
    <Fragment>
      <MiWorkOrderCard {...props} menuItems={menuItems} />
      <WorkOrderHoldModal
        open={isHoldModalOpen}
        onClose={handleHoldModalClose}
        onHold={(data) => submitHold({ ...data, attempt })}
        calendarSet={calendarSet?.config ?? null}
        isLoading={!!isCalendarLoading}
      />
      <MiModalConfirm
        open={isUnassignModalOpen}
        titleIcon={{ path: mdiAccountCancel, color: theme.palette.red.main }}
        title="Unassign Work Order"
        description="Do you want to unassign this work order?"
        loading={!!isCalendarLoading}
        dismissOnBackdropClick={handleUnassignModalClose}
        handleNegative={handleUnassignModalClose}
        handlePositive={() => unscheduleAttempt(attempt)}
      />
    </Fragment>
  );
};
